import m from "mithril";
import Chatbot from "../Chatbot";
export default class MessageInput {

    constructor(
        private readonly chatbot: Chatbot
    ) { }

    private updateHeight(element: HTMLElement): void {
        element.style.height = '5px';
        element.style.height = element.scrollHeight + 'px';
    }

    private isDisabled(): boolean {
        return this.chatbot.state.sending
            || this.chatbot.state.recovering
            || this.chatbot.state.locked
            || !!this.chatbot.state.imageDetailUrl
        ;
    }

    view() {
        return m('.chatbot-input.d-flex.flex-row.flex-nowrap.bg-body-tertiary.w-100.gap-2.p-3', {}, [
            m('textarea.form-control.auto-resize', {
                value: this.isDisabled() ? '' : this.chatbot.state.input,
                disabled: this.isDisabled(),
                placeholder: this.chatbot.translator.translate('ask_me'),
                oncreate: vnode => this.updateHeight(<HTMLTextAreaElement>vnode.dom),
                oninput: e => {
                    this.chatbot.state.input = e.currentTarget.value;
                    this.updateHeight(e.currentTarget);
                },
                onkeydown: async (e: KeyboardEvent) => {
                    if (e.key === 'Enter' && !e.shiftKey && this.chatbot.state.input.trim() && !this.isDisabled()) {
                        e.preventDefault();
                        this.chatbot.state.input = this.chatbot.state.input.trim();
                        await this.chatbot.send();
                        if (e.currentTarget) {
                            this.updateHeight(<HTMLTextAreaElement>e.currentTarget);
                        }
                    }
                },

            }),
            m('label.btn.btn-flat-primary.position-relative.d-none', {
                for: 'chatbot-file-input',
            }, [
                m('span.position-absolute.top-0.start-100.translate-middle.p-1.bg-success.border.border-light.rounded-circle', {
                    id: 'attachment-notification-dot',
                    style: {
                        display: 'none',
                    },
                }),
                m('input[type="file"].d-none', {
                    id: 'chatbot-file-input',
                    onchange: (e: InputEvent) => {
                        const $notificationDot = $('#attachment-notification-dot');
                        $notificationDot.css('display', (<HTMLInputElement>e.target).value ? '' : 'none');
                    }
                }),
                m('i.bi.bi-upload.m-0'),
            ]),
            m('button.btn.btn-flat-primary', {
                onclick: async e => {
                    e.preventDefault();
                    if (this.chatbot.state.input.trim() && !this.isDisabled()) {
                        await this.chatbot.send();
                    }
                },
                disable: this.isDisabled(),
            }, [
                m('i.bi.bi-send')
            ])
        ]);
    }
}
